// Store links — env-driven
// - REACT_APP_TESTFLIGHT_URL: the live App Store listing (name kept for
//   continuity; it is no longer a TestFlight link).
// - REACT_APP_GOOGLE_PLAY_URL: the live Google Play listing.
// - `pending`: store CTAs quietly reroute to the waitlist dialog.
// - `live`:    CTAs open the store chooser modal; Android visitors are routed
//              straight to the Play listing.
// Reading env once at module load is fine because Create React App inlines
// process.env into the bundle at build time.

export const TESTFLIGHT_URL =
  process.env.REACT_APP_TESTFLIGHT_URL || "";

export const GOOGLE_PLAY_URL =
  process.env.REACT_APP_GOOGLE_PLAY_URL || "";

// Android visitors go straight to the Play listing — no store-chooser modal.
export const isAndroid = () =>
  typeof navigator !== "undefined" && /android/i.test(navigator.userAgent || "");

export const isIOS = () =>
  typeof navigator !== "undefined" &&
  (/iphone|ipad|ipod/i.test(navigator.userAgent || "") ||
    // iPadOS reports as Macintosh with touch
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1));

export const TESTFLIGHT_STATUS =
  (process.env.REACT_APP_TESTFLIGHT_STATUS || "pending").toLowerCase();

export const isTestFlightLive = () => {
  // Launch-day preview: append ?launch=live to any URL to see the live state
  // (banner, CTAs, download flow) without flipping the env var.
  if (typeof window !== "undefined") {
    const q = new URLSearchParams(window.location.search);
    if (q.get("launch") === "live") return true;
  }
  return TESTFLIGHT_STATUS === "live" && !!TESTFLIGHT_URL;
};
